import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/Pages/HomePage.vue'
import SolutionsPage from '@/Pages/SolutionsPage.vue'
import FindContractorsComponent from '@/components/FindContractorsComponent.vue'
import Constrapage from '@/components/constra/ConstraPage.vue'
import ConstraSurvey from '@/components/constra/constrasurvey.vue'
import ConstraFaq from '@/components/constra/constrafaq.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/findcontractors',
    name: 'findContractors',
    component: () => import('@/Pages/FindContractorsPage.vue')
  },
  {
    path: '/findcontractorsframe',
    name: 'findcontractorsFrame',
    component: () => import('@/components/FindContractorsComponent.vue')
  },
  {
    path: '/findtenders',
    name: 'findTenders',
    component: () => import('@/Pages/FindTendersPage.vue')
  },
  {
    path: '/solutions',
    name: 'solutions',
    component: () => import('@/Pages/SolutionsPage.vue'),
    children: [
      {
        path: 'contractor',
        name: 'contractor',
        component: SolutionsPage,
      },
      {
        path: 'developer',
        name: 'developer',
        component: SolutionsPage,
      },
      {
        path: 'worker',
        name: 'worker',
        component: SolutionsPage,
      },
      {
        path: 'thekedar',
        name: 'thekedar',
        component: SolutionsPage,
      },
      {
        path: 'thekedar',
        name: 'thekedar',
        component: SolutionsPage,
      },
      {
        path: 'home-owner',
        name: 'home-owner',
        component: SolutionsPage,
      },
      {
        path: 'material-supplier',
        name: 'material-supplier',
        component: SolutionsPage
      },
      {
        path: 'plm',
        name: 'plm',
        component: SolutionsPage
      },
      {
        path: 'ai_project_monitoring',
        name: 'ai_project_monitoring',
        component: Constrapage,
        meta: {
          title: 'CONSTRA - AI-Powered Construction Project Monitoring | Bandhoo',
          description: 'Reduce delays, automate progress reporting, and deliver projects faster with AI. CONSTRA offers drone technology, 360° cameras, and quality management for construction projects.',
          keywords: 'construction project monitoring, AI construction, drone technology, 360 degree camera, quality management, construction automation, project management software',
          robots: 'index, follow',
          ogTitle: 'CONSTRA - AI-Powered Construction Project Monitoring',
          ogDescription: 'Transform your construction projects with AI-driven monitoring, drone technology, and automated progress reporting.',
          ogImage: '/img/constra/constra-scouter-main.png',
          ogUrl: 'https://bandhoo.com/solutions/ai_project_monitoring',
        }
      },
      {
        path: 'constra_survey',
        name: 'constra_survey',
        component: ConstraSurvey,
        meta: {
          title: 'CONSTRA - AI Construction Monitoring & Drone Survey Software | Bandhoo',
          description: 'Transform construction projects with CONSTRA\'s AI-powered project monitoring, drone-based land surveying, and automated progress reporting. Trusted by top real estate developers across India.',
          keywords: 'AI construction monitoring, drone survey software, construction project management, real estate development, site monitoring, progress tracking, digital terrain model, construction automation, India',
          ogTitle: 'CONSTRA - AI-Powered Construction Project Monitoring & Drone Survey Software',
          ogDescription: 'Revolutionize construction management with AI technology, drone surveying, and automated reporting. Reduce delays, improve safety, and track progress in real-time.',
          ogImage: '/img/constra/constra_survey/dsm.png',
          ogUrl: 'https://bandhoo.com/solutions/constra_survey',
          canonical: 'https://bandhoo.com/solutions/constra_survey',
          robots: 'index, follow',
          author: 'Bandhoo Technologies',
          publisher: 'Bandhoo - Construction Technology Platform',
          schema: {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: 'CONSTRA',
            applicationCategory: 'Construction Management Software',
            operatingSystem: 'Web Browser, iOS, Android',
            description: 'AI-powered construction project monitoring and drone survey software for real estate developers and contractors',
            offers: {
              '@type': 'Offer',
              category: 'SaaS Software'
            },
            provider: {
              '@type': 'Organization',
              name: 'Bandhoo Technologies',
              url: 'https://bandhoo.com'
            }
          }
        }
      },
      {
        path: 'constra_faq',
        name: 'constra_faq',
        component: ConstraFaq,
      }
    ]
  },
  {
    path: '/clients',
    name: 'Clients',
    component:  () => import('@/Pages/ClientsPage.vue')
  },
  {
    path: '/about-us',
    name: 'About Us',
    component: () => import('@/Pages/AboutUsPage.vue'),
  },
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: () => import('@/Pages/ContactUsPage.vue')
  },
  {
    path: '/faqs',
    name: 'FAQs',
    component: () => import('@/Pages/FAQPage.vue')
  },
  {
    path: '/digital-shramik',
    name: 'Digital Shramik',
    component: () => import('@/Pages/DigitalShramikPage.vue')
  },
  {
    path: '/terms-of-use',
    name: 'Terms of Use',
    component: () => import('@/Pages/TermsAndConditionsPage.vue')
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('@/Pages/PrivacyPolicyPage.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('@/Pages/BlogPage.vue'),
    meta: {
      title: 'Blog — Bandhoo | Notes from Indian construction by Prashant Gupta',
      description: 'Posts and long-form articles from Prashant Gupta, Founder & CEO of Bandhoo — on construction technology, manpower, cost management, and building a company through it all.',
      robots: 'index, follow',
      canonical: 'https://bandhoo.com/blog',
      ogUrl: 'https://bandhoo.com/blog'
    }
  },
  {
    path: '/blog/article/:id([0-9]+)',
    name: 'Blog Article',
    component: () => import('@/Pages/ArticlePage.vue'),
    meta: {
      robots: 'index, follow'
    }
  },
  {
    path: '/:pathMatch([+]91?[0-9]{10}|[0-9]{10})',
    name: 'contractorWebsite',
    component: () => import('@/Pages/ContractorWebsite.vue'),
  },
  {
    path:'/:pathMatch(.*)',
    name: 'HomePage',
    component: () => import('@/Pages/HomePage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 100, // Offset for fixed header
      };
    } else {
      return { left: 0, top: 0 };
    }
  },
})

export default router
